export default {
  en: {
    breadcrumb: 'Your Backup List',
    cardHeader: {
      title: 'Your backup list'
    },
    table: {
      thVPS: 'VPS',
      thLastBackup: 'Last backup',
      thNextBackup: 'Next backup',
      thImageName: 'OS Version',
      thSize: 'Disk size',
      thStatus: 'Status',
      thPeriod: 'Period',
      thManage: 'Manage',

      tdRecover: 'Recover',
      tdDelete: 'Delete'
    },
    modal: {
      deleteTitle: 'Confirm delete backup?',
      bodyWarningDisable: 'This will also disable backup on the VPS. If you are being charged for the backup disk, it will ' +
        'be automatically adjusted next month.',
      bodyWarningDelete: 'Do you really want to delete this backup? The backup will be permanently destroyed.',
      buttonDelete: 'Delete',

      recoverTitle: 'Confirm recover VPS from backup?',
      bodyWarningRecover: 'The following VPS will be overwrite with the backup',
      bodyWarningRecoverDataLoss: 'All the current data will be deleted permanently. Are you sure?',
      buttonRecover: 'Recover'
    },
    toast: {
      errBackupNotActive: 'The backup is not ready yet! Please wait or contact support!'
    }
  },
  vi: {
    breadcrumb: 'Danh Sách Sao Lưu',
    cardHeader: {
      title: 'Danh sách bản sao lưu'
    },
    table: {
      thVPS: 'Cloud VPS',
      thLastBackup: 'Sao lưu mới nhất',
      thNextBackup: 'Sao lưu tiếp theo',
      thImageName: 'Hệ điều hành',
      thSize: 'Size ổ cứng',
      thStatus: 'Trạng thái',
      thPeriod: 'Chu kỳ',
      thManage: 'Quản lý',

      tdRecover: 'Phục hồi',
      tdDelete: 'Xóa'
    },
    modal: {
      deleteTitle: 'Xác nhận xóa bản sao lưu?',
      bodyWarningDisable: 'Việc này cũng sẽ tắt chức năng tự động sao lưu của VPS này. Nếu bạn đang thanh toán cho chức năng tự động sao lưu, ' +
        'hệ thống sẽ tự động điều chỉnh giá VPS vào tháng tiếp theo.',
      bodyWarningDelete: 'Bạn thực sự muốn xóa bản sao lưu này?',
      buttonDelete: 'Xóa',

      recoverTitle: 'Xác nhận phục hồi VPS từ bản sao lưu?',
      bodyWarningRecover: 'VPS dưới dây sẽ bị ghi đè bởi bàn sao lưu',
      bodyWarningRecoverDataLoss: 'Tất cả dữ liệu hiện tại sẽ bị xóa và thay thế bởi dữ liệu trong bản backup. Bạn có chắc chắn muốn thực hiện?',
      buttonRecover: 'Phục hồi'
    },
    toast: {
      errBackupNotActive: 'Bản sao lưu chưa sẵn sàng! Vui lòng chờ trong ít phút hoặc liên hệ hỗ trợ!'
    }
  },
  zh: {
    cardHeader: {
      title: '备份名单'
    },
    table: {
      thVPS: 'VPS',
      thLastBackup: '最新备份',
      thNextBackup: '继续备份',
      thImageName: '操作系统',
      thSize: '硬盘容量',
      thStatus: '状态',
      thPeriod: '周期',
      thManage: '管理',

      tdRecover: '恢复',
      tdDelete: '删除'
    },
    modal: {
      deleteTitle: '确认删除备份?',
      bodyWarningDisable: '此操作会关掉这个VPS的自动备份功能, ' +
        '如果您已经缴费自动备份功能系统将会在下个月调整价钱.',
      bodyWarningDelete: '您是否确认要删除这份备份?',
      buttonDelete: '删除',

      recoverTitle: '是否确认从此VPS恢复备份?',
      bodyWarningRecover: '此VPS会被此备份覆盖',
      bodyWarningRecoverDataLoss: '此操作会删除原有的所有资料文件然后会被您所选的备份覆盖。你是否确认恢复?',
      buttonRecover: '恢复'
    },
    toast: {
      errBackupNotActive: '备份未完成！请稍等片刻 或者联系客服!'
    }
  }
}
